import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { ASSISTANT_CHAT_HISTORY_URL, ASSISTANT_CHAT_SEND_URL } from '../constants';
import { AuthContext } from './AuthContext';

const ChatContext = createContext();

const ChatProvider = ({ children }) => {
  const [chatMenu, setChatMenu] = useState([]);           // Lista de historiales
  const [chatMessage, setChatMessage] = useState([]);     // Mensajes activos
  const [chatShow, setChatShow] = useState(false);        // Mostrar chat
  const [showChatTime, setShowChatTime] = useState(new Date().toISOString()); // Timestamp

  const { user } = useContext(AuthContext);

  // 🧠 Detecta el identificador de usuario desde AuthContext
  const userId = user?.username || user?.IDalumno || "anonimo";

  // 📥 Carga historial del usuario al montar o al cambiar la marca de tiempo
  useEffect(() => {
    const fetchChatHistory = async () => {
      try {
        const response = await axios.get(ASSISTANT_CHAT_HISTORY_URL, {
          params: { userid: userId }
        });
        const menu = (response.data?.menu || []).reverse();
        setChatMenu(menu);
      } catch (error) {
        console.error('Error fetching chat history:', error.message);
      }
    };

    if (userId && userId !== "anonimo") {
      fetchChatHistory();
    }
  }, [userId, showChatTime]);

  // ✉️ Enviar mensaje (con archivos opcionales)
  const sendMessage = async (message, files = []) => {
    try {
      const formData = new FormData();
      formData.append("message", message);
      formData.append("userId", userId);
      formData.append("time", showChatTime);
      files.forEach(file => formData.append("files", file));

      const response = await axios.post(ASSISTANT_CHAT_SEND_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const { answer, folder, citations } = response.data;

      const newEntry = {
        question: message,
        answer,
        folder,
        citations
      };

      setChatMenu(prev => [...prev, newEntry]);
      return answer;
    } catch (error) {
      console.error('Error sending message:', error.message);
      throw error;
    }
  };

  return (
    <ChatContext.Provider value={{
      chatMenu, setChatMenu,
      chatMessage, setChatMessage,
      chatShow, setChatShow,
      showChatTime, setShowChatTime,
      sendMessage
    }}>
      {children}
    </ChatContext.Provider>
  );
};

export { ChatContext, ChatProvider };
